import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { ErrorContext } from '../../lib/ErrorContext';
import { ToastContainer } from 'react-toastify';
import { isEmbedded } from '../lib/PageHelpers.js';
import { sendResize } from '../lib/EmbedMessaging.js';
import * as Sentry from '@sentry/react';
import ErrorPage from '../../pages/ErrorPage.jsx';

const PublicLayout = ({}) => {
    const [errors, setErrors] = useState({});
    const [errorsUpdatedAt, setErrorsUpdatedAt] = useState();
    const { pathname } = useLocation();

    useEffect(() => {
        setErrors({});
    }, [pathname]);

    useEffect(() => {
        sendResize();
        let lastSize = document.body.scrollHeight;
        let lastSizeChange = null;
        const sizeChangeRateLimit = 250;

        const interval = setInterval(function () {
            const newSize = document.body.scrollHeight;
            const minSizeChange = 10; // don't send resize if it's a small change
            const minBigSizeChange = 200; // Bigger resizes don't rate limit
            //console.log('checking size', Math.abs(newSize - lastSize), (!lastSizeChange || (new Date())-lastSizeChange))
            const sizeDifference = Math.abs(newSize - lastSize);
            if (sizeDifference > minSizeChange) {
                if (
                    !lastSizeChange ||
                    new Date() - lastSizeChange > sizeChangeRateLimit ||
                    sizeDifference > minBigSizeChange
                ) {
                    sendResize();
                    lastSizeChange = new Date();
                }

                lastSize = newSize;
            }
        }, 100);

        return () => clearInterval(interval);
    }, []);

    return (
        <Sentry.ErrorBoundary fallback={<ErrorPage />}>
            <ErrorContext.Provider
                value={{
                    errors: errors,
                    setErrors: setErrors,
                    setErrorsUpdatedAt: setErrorsUpdatedAt,
                    errorsUpdatedAt: errorsUpdatedAt,
                }}
            >
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                <div className={`${isEmbedded() ? 'is-embedded' : ''}`}>
                    <Outlet />
                </div>
            </ErrorContext.Provider>
        </Sentry.ErrorBoundary>
    );
};

export default PublicLayout;
